<div class="card-header bg-white" *ngIf="accessService.authorized(project, 'EDIT_ORGANISATION')">

    <ng-template #authTemplate><div [innerHtml]="accessService.authReason(project, 'EDIT_ORGANISATION')"></div></ng-template>
    <button type="button" class="btn btn-primary" placement="right" containerClass="auth-tooltip"
            *ngIf="viewMode === ViewMode.VIEW"
            (click)="setMode(ViewMode.EDIT)"
            [tooltip]="authTemplate"
            [delay]="500">Bearbeiten
    </button>

    <ng-container *ngIf="viewMode === ViewMode.EDIT">
        <button type="button" class="btn btn-success" [disabled]="form.invalid" (click)="update()">Speichern</button>
        <button type="button" class="btn btn-secondary ms-2" (click)="cancelEdit()">Abbrechen</button>
    </ng-container>
</div>
<div class="card-body">
    <form [formGroup]="form">

        <div class="row">
            <div class="col">
                <div class="mb-2">
                    <label>Länderbereich</label>
                    <select class="form-control" formControlName="id_region" *ngIf="viewMode !== ViewMode.VIEW">
                        <option value="" disabled selected style="display: none;">Länderbereich auswählen</option>
                        <option *ngFor="let region of regions" [ngValue]="region.id">
                            Region {{ region.region }} ({{ region.countries }})
                        </option>
                    </select>
                    <p *ngIf="viewMode === ViewMode.VIEW">
                        {{ form.value.region }}
                        <span class="text-muted" *ngIf="!form.value.region">Nicht eingetragen</span>
                    </p>
                </div>
            </div>
            <div class="col">
                <div class="mb-2">
                    <label>Abteilung</label>
                    <select class="form-control" formControlName="id_department" *ngIf="viewMode !== ViewMode.VIEW">
                        <option value="" disabled selected style="display: none;">Abteilung auswählen</option>
                        <option *ngFor="let department of departments" [ngValue]="department.id">
                            {{ department.name }} ({{ department.lead }})
                        </option>
                    </select>
                    <p *ngIf="viewMode === ViewMode.VIEW">
                        {{ form.value.department }}
                        <span class="text-muted" *ngIf="!form.value.department">Nicht eingetragen</span>
                    </p>
                </div>
            </div>
        </div>

        <h4>Team ({{getLengthOfFormArray('team')}} Personen)</h4>

        <p *ngIf="getLengthOfFormArray('team') === 0">Keine Teammitglieder definiert.</p>

        <table class="table table-striped table-sm" *ngIf="getLengthOfFormArray('team') > 0">
            <thead>
            <tr>
                <th style="width: 50px" *ngIf="viewMode !== ViewMode.VIEW"></th>
                <th style="width: 180px">Rolle</th>
                <th>Name</th>
            </tr>
            </thead>
            <tbody formArrayName="team">
            <tr [formGroupName]="i"
                *ngFor="let entry of formService.getFormArray(form, 'team').controls; let i = index">
                <ng-container *ngIf="!entry.value._deleted">
                    <td *ngIf="viewMode !== ViewMode.VIEW">
                        <button type="button" class="btn btn-danger btn-sm"
                                *ngIf="canBeDeleted(entry)"
                                (click)="markEntryAsDeleted(entry)"
                                [disabled]="controlsDisabled"><i
                                class="fas fa-times"></i></button>
                    </td>
                    <td>
                        <ng-container *ngIf="entry.value.id === null">
                            <select class="form-control" formControlName="role"
                                    *ngIf="viewMode !== ViewMode.VIEW"
                                    [disableControl]="controlsDisabled">
                                <option value="" disabled selected style="display: none;">Bitte auswählen</option>
                                <option *ngFor="let role of teamRoleListNew" [ngValue]="role">
                                    {{ role | teamRole }}
                                </option>
                            </select>
                        </ng-container>

                        <ng-container *ngIf="entry.value.id !== null">
                            <select class="form-control" formControlName="role"
                                    *ngIf="viewMode !== ViewMode.VIEW"
                                    [disableControl]="entry.value.id && controlsDisabled">
                                <option value="" disabled selected style="display: none;">Bitte auswählen</option>
                                <option *ngFor="let role of teamRoleList" [ngValue]="role">
                                    {{ role | teamRole }}
                                </option>
                            </select>
                        </ng-container>

                        <ng-container *ngIf="viewMode === ViewMode.VIEW">{{ entry.value.role | teamRole }}</ng-container>
                    </td>
                    <td>
                        <ng-container *ngIf="entry.getRawValue().role === TeamRole.Customer">
                            <select class="form-control" formControlName="id_member"
                                    *ngIf="viewMode !== ViewMode.VIEW"
                                    [disableControl]="entry.value.id && controlsDisabled">
                                <option value="" disabled selected hidden>Leistungsempfänger (Kunde) der Projektergebnisse</option>
                                <option *ngFor="let customer of customers" [value]="customer.id">
                                    {{ customer.name }}
                                </option>
                            </select>
                        </ng-container>
                        <ng-container *ngIf="[TeamRole.Employee, TeamRole.EmployeeExternal].includes(entry.getRawValue().role)">
                            <input type="text" class="form-control" formControlName="member"
                                   placeholder="Experten für spezielle Bereiche und verantwortlich für die inhaltliche Erledigung der zugeteilten Aufgaben"
                                   *ngIf="viewMode !== ViewMode.VIEW"
                                   [disableControl]="entry.value.id && controlsDisabled">
                        </ng-container>
                        <ng-container *ngIf="[TeamRole.LeadExternal].includes(entry.getRawValue().role)">
                            <input type="text" class="form-control" formControlName="member"
                                   placeholder="Gesamtverantwortlich für die Erreichung der definierten Ziele und Koordination des Projektfortschritts, erster Ansprechpartner für Projektthemen"
                                   *ngIf="viewMode !== ViewMode.VIEW"
                                   [disableControl]="entry.value.id && controlsDisabled">
                        </ng-container>
                        <ng-container *ngIf="entry.getRawValue().role === TeamRole.Orderer">
                            <select class="form-control" formControlName="id_member"
                                    *ngIf="viewMode !== ViewMode.VIEW"
                                    [disableControl]="entry.value.id && controlsDisabled">
                                <option value="" disabled selected hidden>Initiator eines Projektes, oberste Entscheidungsinstanz im Projekt, verantwortlich für die Bereitstellung und Freigabe von Projektressourcen</option>
                                <option *ngFor="let orderer of orderers" [value]="orderer.id">
                                    {{ orderer.name }}
                                </option>
                            </select>
                        </ng-container>
                        <ng-container *ngIf="entry.getRawValue().role === TeamRole.Lead">
                            <select class="form-control" formControlName="id_member"
                                    *ngIf="viewMode !== ViewMode.VIEW"
                                    [disableControl]="entry.value.id && controlsDisabled">
                                <option value="" disabled selected hidden>Gesamtverantwortlich für die Erreichung der definierten Ziele und Koordination des Projektfortschritts, erster Ansprechpartner für Projektthemen</option>
                                <option *ngFor="let lead of leads" [value]="lead.id">
                                    {{ lead.name }}
                                </option>
                            </select>
                        </ng-container>
                        <ng-container *ngIf="viewMode === ViewMode.VIEW">
                            <ng-container *ngIf="entry.value.member">{{ entry.value.member }}</ng-container>
                            <ng-container *ngIf="entry.value.member_alt">{{ entry.value.member_alt }}</ng-container>
                            <div class="text-danger" *ngIf="!entry.value.member && !entry.value.member_alt">Nicht gesetzt</div>
                        </ng-container>
                    </td>
                </ng-container>
            </tr>
            </tbody>
        </table>

        <div *ngIf="viewMode !== ViewMode.VIEW">
            <button type="button" class="btn btn-primary btn-sm" (click)="addFormItem({}, 'team')">
                <i class="fas fa-plus"></i> Teammitglied hinzufügen
            </button>
        </div>

    </form>
</div>
